<template>
    <div class="app has-header">
        <div class="header main">
            <div class="align-left"></div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right"></div>
        </div>
        <div class="scrollbar-container">
            <div class="header top">
                <div class="label">{{ $tc('pages.comp.freeTimeOptions', 2) }}</div>
            </div>
            <datatable :state="dataTableState" />
            <div v-if="loading" class="loading-md bg">
                <i class="fas fa-spinner"></i>
                <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                    {{ loadingText }}
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import datatable from '../uicomponents/datatable.vue';
    import { mapState, mapGetters } from 'vuex';
    export default {
        name: 'employeerulesoverviewtable',
        components: {
            datatable,
        },
        data () {
            return {
                loadingText: this.$t('global.ui.loadX', [this.$tc('pages.comp.freeTimeOptions', 2)]),
                loading: true,
            }
        },
        created: function () {
            if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                this.refresh();
            }
        },
        computed: {
            ...mapGetters(['storeId', 'employeeRulesMap', 'employeeRulesTemplateMap']),
            headerButtons() {
                let view = this;
                let helperLinks = [];
                let buttons = [
                    {
                        type: "block",
                        icon: "fa-sync-alt",
                        click: () => {
                        view.refresh(true); 
                        },
                        tooltip: this.$t('global.general.refreshData')
                    },
                    {
                        classes: "add-employeerules",
                        type: "block green",
                        disabled: false,
                        icon: "fa-plus",
                        click: ($event) => { 
                            this.CreateRules($event);
                            },
                        show:  true,
                        tooltip: this.$t('pages.comp.addFreeTimeOptions'),
                        helperText: this.$t('pages.comp.addFreeTimeOptionsHelp'),
                        
                    }
                ];
                helperLinks.push(
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/12",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close')
                    }
                );
                let state= {
                    buttons: buttons,
                    helperLinks: helperLinks,
                    showListIconAlways: true
                    };
                return state;
            },
            dataTableState(){
                let view = this;
                let state = {};
                let rules = Object.values(this.employeeRulesMap);
                rules.sort((a, b) => {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                })
                state = this.$helpers.GetDataTableStateFromObject({
                    name: '',
                }, rules);
                state.headerMap['name'].sort = true;
                state.headerMap['name'].align = 'left';
                state.headerMap['name'].alignHeaderLabel = 'left';
                state.headerMap['name'].DisplayLabel = (i) => {return i.name};
                state.headerMap['actions'] = {buttons:[
                        {icon: 'fas fa-eye', action: ($event, data) => view.ViewRules($event, data)},
                        {icon: 'fas fa-edit', action: ($event, data) => view.EditRules($event, data)},
                        {icon: 'fas fa-trash', action: ($event, data) => view.DeleteRules($event, data)},
                    ]};
                state.headerMap['actions'].width = '120px';
                
                return state;
            },
            

        },
        watch: {
            storeId(newVal, oldVal){
                this.refresh();
            }
        },
        // methods that implement data logic.
        methods: {
            refresh: function(forced = false){
                
                let view = this;
                this.loading = true;

                this.$helpers.GetEmployeeRulesTemplateMap(forced)  
                .then(response => {
                    return view.$helpers.GetEmployeeRulesMap(forced)
                }).then(response => {
                    view.loading = false;
                }).catch(function (error) {
                    console.log(error)
                })
            },
            DeleteRules($event, data){
                let view = this;
                view.$helpers.OpenAlert({header: this.$t('global.ui.deleteX', [this.$tc('pages.comp.freeTimeOptions', 2)]), description: this.$t('pages.comp.deleteFreeTimeQuery', [data.name]), callbackAccept: (alert) => {
                        alert.hidden = true;
                        view.$helpers.DeleteCall('/api/sec/employeerules', data, () => {
                            view.$store.commit("deleteEmployeeRulesMapEntry", {id: data.id});
                        });
                    }});
            },
            CreateRules($event, data){
                let view = this;
                
                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'employeerulesform',
                    componentState: {employeeRulesTemplateMap: this.employeeRulesTemplateMap},
                    expanded: true,
                    centered: true,
                    width: '1000px',
                    header: this.$t('global.ui.newX', [this.$tc('pages.comp.freeTimeOptions')]),
                    customEventName:"created-employeerules",
                    customEventHandler:(data) => { view.$store.commit("setEmployeeRulesMapEntry", data);}
                });
            },
            EditRules($event, data){
                let view = this;
                
                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'employeerulesform',
                    componentState: {employeeRulesTemplateMap: this.employeeRulesTemplateMap, employeeRules: data},
                    expanded: true,
                    centered: true,
                    width: '1000px',
                    header: this.$t('global.ui.editX', [this.$tc('pages.comp.freeTimeOptions')]),
                    customEventName:"updated-employeerules",
                    customEventHandler:(data) => {delete data.updateFields; view.$store.commit("setEmployeeRulesMapEntry", data); }
                });
            },
           
            ViewRules($event, data){
                let view = this;
               
                let rulesTemp = {};
                let name = data.name;
                rulesTemp.templateName = this.employeeRulesTemplateMap[data.templateId] ? this.employeeRulesTemplateMap[data.templateId].name : '';
                rulesTemp.desiredR = data.rules.desiredR;
                rulesTemp.undesiredR = data.rules.undesiredR;
                rulesTemp.weekendR = data.rules.weekendR;
                rulesTemp.weekendDaysR = data.rules.weekendDaysR;
                rulesTemp.skillR = data.rules.skillR;
                rulesTemp.bioR = data.rules.bioR;

                let datafillState = view.$helpers.GetDataFillStateFromObject(rulesTemp);
                Object.values(datafillState.entries).forEach(e => {
                    e.flexGroup = true;
                    e.styles = {width: '50%'};
                });

                datafillState.entries.templateName.label = this.$tc('pages.employeeContract.template');
                datafillState.entries.templateName.styles = {width: '50%', left : '-25%'};
                datafillState.entries.templateName.flexRowEnd = true;
                datafillState.entries.desiredR.label = this.$t('pages.comp.preferencesWeight');
                datafillState.entries.undesiredR.label = this.$t('pages.comp.dislikeWeight');
                datafillState.entries.weekendR.label = this.$t('pages.comp.freeWeekendsWeight');
                datafillState.entries.weekendDaysR.label = this.$t('pages.comp.weekendDaysWeight');
                datafillState.entries.skillR.label = this.$t('pages.comp.considerSkills');
                datafillState.entries.bioR.label = this.$t('pages.comp.biorhythmWeight');
                

                datafillState.displayOnly = true;

                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'datafill',
                    componentState: datafillState,
                    expanded: true,
                    centered: true,
                    width: '1000px',
                    header: name,
                });
            },

            
            
        },

    }
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
    .header.top{
        margin: 10px 0px 10px 8px;
    }
    .data-table{
        top: 10px;
        position: relative;
    }
    .employee-rules-table{
        padding: 0px 14px;
    }
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        overflow-x: hidden;
        top: var(--header-height);
        padding: 0px 14px;
    }
</style>
